var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component } from 'vue-property-decorator';
Component.registerHooks([
    'beforeRouteLeave'
]);
var Savable = /** @class */ (function (_super) {
    __extends(Savable, _super);
    function Savable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.savingTimeout = 15000; // 15s
        _this.lockingTimeout = 15000; // 15s
        return _this;
    }
    Savable.prototype.touch = function () {
        if (!this.isReadOnly)
            this.lock = true;
    };
    Savable.prototype.change = function () {
        //console.log("change");
        if (!this.isReadOnly)
            this.dirty = true;
    };
    Savable.prototype.blur = function () {
        if (!this.isReadOnly)
            this.modified = true;
    };
    Savable.prototype.forceSave = function () {
        var _this = this;
        this.touch();
        this.change();
        this.$nextTick(function () {
            _this.blur();
        });
    };
    Object.defineProperty(Savable.prototype, "lock", {
        get: function () {
            return this.$store.state.vuexPageModule.lock;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOCK", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "locking", {
        get: function () {
            return this.$store.state.vuexPageModule.locking;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOCKING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "dirty", {
        get: function () {
            return this.$store.state.vuexPageModule.dirty;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_DIRTY", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "modified", {
        get: function () {
            return this.$store.state.vuexPageModule.modified;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_MODIFIED", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "saving", {
        get: function () {
            return this.$store.state.vuexPageModule.saving;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_SAVING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "saveFailed", {
        get: function () {
            return !this.saving && this.$store.state.vuexPageModule.saveFailed;
        },
        set: function (value) {
            if (value) { //failure
                this.$store.commit("vuexPageModule/SET_SAVED", false);
                this.dirty = true;
            }
            this.$store.commit("vuexPageModule/SET_SAVEFAILED", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "saved", {
        get: function () {
            return !this.saving && !this.saveFailed && this.$store.state.vuexPageModule.saved;
        },
        set: function (value) {
            if (value) { //success
                this.$store.commit("vuexPageModule/SET_SAVEFAILED", false);
                this.dirty = false;
                this.modified = false;
            }
            this.$store.commit("vuexPageModule/SET_SAVED", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "sectionLockStatus", {
        get: function () {
            return this.$store.state.vuexPageModule.sectionLockStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "isReadOnly", {
        get: function () {
            return this.isInLockedState
                || this.isPastDeadline
                || this.isLockedForAnotherUser
                || this.isLockedForAnotherApp
                || this.isCustomReadOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "isInLockedState", {
        get: function () {
            return this.sectionLockStatus.isLockedState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "isPastDeadline", {
        get: function () {
            return this.sectionLockStatus.isPastDeadline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "isLockedForAnotherUser", {
        get: function () {
            return this.sectionLockStatus.isLockedForAnotherUser;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "isLockedForAnotherApp", {
        get: function () {
            return this.sectionLockStatus.isLockedForAnotherApp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "isCustomReadOnly", {
        get: function () {
            return this.$store.getters["vuexPageModule/customReadOnly"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Savable.prototype, "savingInstances", {
        get: function () {
            return this.$store.state.vuexPageModule.savingInstances;
        },
        enumerable: false,
        configurable: true
    });
    Savable.prototype.incrementSavingInstances = function () {
        this.$store.commit("vuexPageModule/INC_SAVINGINSTANCES");
    };
    Savable.prototype.decrementSavingInstances = function () {
        this.$store.commit("vuexPageModule/DEC_SAVINGINSTANCES");
    };
    Savable.prototype.resetSavingInstances = function () {
        this.$store.commit("vuexPageModule/RESET_SAVINGINSTANCES");
    };
    /**
     * Runs before _any_ route change
     */
    Savable.prototype.beforeRouteLeave = function (to, from, next) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Make sure that the document is saved before moving to a different route
                    return [4 /*yield*/, this.waitUntilSaved()];
                    case 1:
                        // Make sure that the document is saved before moving to a different route
                        _a.sent();
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/cleanSectionState")];
                    case 2:
                        _a.sent();
                        next();
                        return [2 /*return*/];
                }
            });
        });
    };
    Savable.prototype.waitUntilSaved = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitUntilFlag(function () { return (_this.dirty || _this.modified || _this.locking || _this.savingInstances > 0); }, this.savingTimeout)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Savable.prototype.waitUntilLocked = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitUntilFlag(function () { return _this.locking; }, this.lockingTimeout)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Savable.prototype.waitUntilFlag = function (fn, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var delay, waited;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delay = 1000;
                        waited = 0;
                        _a.label = 1;
                    case 1:
                        if (!(fn() && waited < timeout)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.delay(delay)];
                    case 2:
                        _a.sent();
                        waited += delay;
                        return [3 /*break*/, 1];
                    case 3:
                        if (waited >= timeout) {
                            throw new Error("Timeout expired");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Savable.prototype.delay = function (ms) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
            });
        });
    };
    Savable = __decorate([
        Component
    ], Savable);
    return Savable;
}(Vue));
export { Savable };
